class ProductCard extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    if (this.form) {
      this.form.addEventListener('submit', this.addToCart.bind(this));
    }
  }

  async addToCart(event) {
    event.preventDefault();
    
    const submitBtn = this.form.querySelector('button[type="submit"]');
    
    submitBtn.setAttribute('disabled', true);
    submitBtn.classList.add('loading');

    const formData = new FormData(this.form);
    
    try {
      const cartResponse = await CartApi.addToCart(formData, {
        variantData: this.form.dataset
      });
      const cart = await CartApi.refreshCart(cartResponse);
      document.dispatchEvent(new CustomEvent('cart:added', { detail: cart || cartResponse }));

      if (!window.SimpleHeaderCart?.open) {
        const cartTrigger =
          document.getElementById('simple-header-cart-trigger') ||
          document.getElementById('custom-header-cart-trigger');
        if (cartTrigger) {
          cartTrigger.click();
        }
      }

    } catch (error) {
      CartApi.showToast(error.message, true);
    } finally {
      submitBtn.removeAttribute('disabled');
      submitBtn.classList.remove('loading');
    }
  }
}

if (!customElements.get('product-card')) {
  customElements.define('product-card', ProductCard);
}
